const Actions = require('../actions');
const Button = require('../../../../components/form/button.jsx');
const ControlGroup = require('../../../../components/form/control-group.jsx');
const PropTypes = require('prop-types');
const React = require('react');
const ReactHelmet = require('react-helmet');
const ReactRouter = require('react-router-dom');
const Spinner = require('../../../../components/form/spinner.jsx');
const Store = require('./store');
const TextControl = require('../../../../components/form/text-control.jsx');
const UserIdentity = require('../../../../helpers/user-identity');

const ObjectAssign = require('object-assign');

const Helmet = ReactHelmet.Helmet;
const Link = ReactRouter.Link;
const Redirect = ReactRouter.Redirect;

const propTypes = {
    match: PropTypes.object
};


class ResetPage extends React.Component {
    constructor(props) {

        super(props);

        this.input = {};
        this.state = Store.getState();
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
    }

    componentDidMount() {

        this.unsubscribeStore = Store.subscribe(this.onStoreChange.bind(this));

        if (this.input.password) {
            this.input.password.focus();
        }
    }

    componentWillUnmount() {

        this.unsubscribeStore();
    }

    onStoreChange() {

        this.setState(Store.getState());
    }

    handleSubmit(event) {
        event.preventDefault();
        event.stopPropagation();

        Actions.reset({
            email: this.props.match.params.email,
            key: this.props.match.params.key,
            password: this.input.password.value()
        });
    }
    handlePasswordChange(event) {
        let value = event.target.value;

        /*set 8 char minimum*/
        if(value.length < 8)
            this.setState(ObjectAssign(this.state, {
                conditionCharacter: false
            }));
        else
            this.setState(ObjectAssign(this.state, {
                conditionCharacter: true
            }));

        /*set one upper case*/
        if(!/[A-Z]/.test(value))
            this.setState(ObjectAssign(this.state, {
                conditionUpperCase: false
            }));
        else
            this.setState(ObjectAssign(this.state, {
                conditionUpperCase: true
            }));

        /*set one number*/
        if(value.match(/\d/))
            this.setState(ObjectAssign(this.state, {
                conditionNumber: true
            }));
        else
            this.setState(ObjectAssign(this.state, {
                conditionNumber: false
            }));

        /*set one lower case*/
        if(!/[a-z]/.test(value))
            this.setState(ObjectAssign(this.state, {
                conditionLowerCase: false
            }));
        else
            this.setState(ObjectAssign(this.state, {
                conditionLowerCase: true
            }));

        /*check all errors active*/
        if (this.state.conditionUpperCase && 
            this.state.conditionLowerCase && 
            this.state.conditionNumber && 
            this.state.conditionCharacter) {
            this.setState(ObjectAssign(this.state, {
                conditionPassword: false
            }));
        } else {
            this.setState(ObjectAssign(this.state, {
                conditionPassword: true
            }));
        }
    }
    render() {
        if (UserIdentity._checkUserIdentity()) {
            return <Redirect to='/' push />;
        }
        const alerts = [];

        if (this.state.success) {
            alerts.push(<div key="success">
                <div className="alert alert-success">
                    Your password has been reset. Please login to confirm.
                </div>
                <h4 className="sub-title">Have a Dining Power account? 
                    <Link to="/login"> Sign in</Link>
                </h4>
            </div>);
        }

        if (this.state.error) {
            alerts.push(<div key="danger" className="alert alert-danger">
                {this.state.error}
            </div>);
        }

        let formElements;

        if (!this.state.success) {
            formElements = <fieldset>
                <TextControl
                    ref={(c) => (this.input.password = c)}
                    name="password"
                    hideLabel={true}
                    placeholder="Create a Password"
                    type="password"
                    hasError={this.state.hasError.password}
                    help={this.state.help.password}
                    disabled={this.state.loading}
                    onChange={this.handlePasswordChange}
                    groupClasses={{ 'mb0': true }}
                />
                <ControlGroup hideLabel={true} hideHelp={true} groupClasses={{ 'valid': true }}>
                    <span>
                        <i className={this.state.conditionCharacter ? "fa fa-check green" : "fa fa-circle"} aria-hidden="true"></i> 
                        8 characters minimum
                    </span>
                    <span className="pull-right">
                        <i className={this.state.conditionUpperCase ? "fa fa-check green" : "fa fa-circle"} aria-hidden="true"></i>
                        One uppercase character
                    </span>
                    <span>
                        <i className={this.state.conditionNumber ? "fa fa-check green" : "fa fa-circle"}  aria-hidden="true"></i>
                        One number
                    </span>
                    <span className="pull-right">
                        <i className={this.state.conditionLowerCase ? "fa fa-check green" : "fa fa-circle"} aria-hidden="true"></i>
                        One lowercase character
                    </span>
                </ControlGroup>
                <TextControl
                    type="hidden"
                    hideLabel={true}
                    name="_key"
                    hasError={this.state.hasError.key}
                    value={this.props.match.params.key}
                    help={this.state.help.key}
                    disabled={true}
                />
                <TextControl
                    type="hidden"
                    hideLabel={true}
                    name="_email"
                    hasError={this.state.hasError.email}
                    value={this.props.match.params.email}
                    help={this.state.help.email}
                    disabled={true}
                />
                <ControlGroup hideLabel={true} hideHelp={true}>
                    <Button
                        type="submit"
                        inputClasses={{ 'full': true, 'mtb16' : true }}
                        disabled={this.state.loading}>

                        Set password
                        <Spinner space="left" show={this.state.loading} />
                    </Button>
                    <h4 className="sub-title">Have a Dining Power account? 
                        <Link to="/login"> Sign in</Link>
                    </h4>
                </ControlGroup>
            </fieldset>;
        }

        return (
            <section className="login-register">
                <Helmet>
                    <title>Reset password</title>
                </Helmet>
                <div className="container">
                    <div className="login-left equal">
                        <div className="login-img">
                        <img src="/public/media/images/login.png" alt="Reset Password"/>
                        </div>
                    </div>
                    <div className="login-right equal">
                        <div className="custom-modal">
                            <div className="modal-dialog">
                                <div className="modal-content reset-part">
                                    <div className="modal-header">
                                        <h4 className="modal-title">Create a Password</h4>
                                        <h4 className="sub-title normal">We’ll send you a link to reset your password.</h4>
                                    </div>
                                    <div className="modal-body">
                                        <form onSubmit={this.handleSubmit.bind(this)}>
                                            {alerts}
                                            {formElements}
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

ResetPage.propTypes = propTypes;


module.exports = ResetPage;



// WEBPACK FOOTER //
// client/pages/main/login/reset/index.jsx